export default __webpack_public_path__ + "static/t-ipx-6eec701e6d1777f548054026f5e57de1.png";